import React from 'react';
import { ArrowUpRightIcon, ArrowDownRightIcon } from 'lucide-react';
interface StatCardProps {
  title: string;
  value: string | number;
  change: number;
  icon: React.ReactNode;
  accentColor: 'teal' | 'gold' | 'green' | 'orange' | 'blue';
}
export function StatCard({
  title,
  value,
  change,
  icon,
  accentColor
}: StatCardProps) {
  const isPositive = change >= 0;
  const colorMap = {
    teal: 'text-mavis-teal bg-mavis-teal/10',
    gold: 'text-mavis-gold bg-mavis-gold/10',
    green: 'text-mavis-green bg-mavis-green/10',
    orange: 'text-mavis-orange bg-mavis-orange/10',
    blue: 'text-mavis-blue bg-mavis-blue/10'
  };
  const borderMap = {
    teal: 'border-b-mavis-teal',
    gold: 'border-b-mavis-gold',
    green: 'border-b-mavis-green',
    orange: 'border-b-mavis-orange',
    blue: 'border-b-mavis-blue'
  };
  return <div className={`bg-white rounded-none p-6 shadow-sm border border-gray-100 border-b-4 ${borderMap[accentColor]} transition-all hover:shadow-md`} data-id="element-236">

      <div className="flex justify-between items-start mb-4" data-id="element-237">
        <div data-id="element-238">
          <p className="text-sm font-medium text-gray-500 mb-1" data-id="element-239">{title}</p>
          <h3 className="text-2xl font-bold text-gray-900 font-mono" data-id="element-240">
            {value}
          </h3>
        </div>
        <div className={`p-3 rounded-none ${colorMap[accentColor]}`} data-id="element-241">
          {icon}
        </div>
      </div>
      <div className="flex items-center text-sm" data-id="element-242">
        <span className={`flex items-center font-medium ${isPositive ? 'text-mavis-green' : 'text-mavis-orange'}`} data-id="element-243">

          {isPositive ? <ArrowUpRightIcon className="w-4 h-4 mr-1" data-id="element-244" /> : <ArrowDownRightIcon className="w-4 h-4 mr-1" data-id="element-245" />}
          {Math.abs(change)}%
        </span>
        <span className="text-gray-400 ml-2" data-id="element-246">vs last month</span>
      </div>
    </div>;
}